// extracted by mini-css-extract-plugin
module.exports = {"container":"quote-module--container--2tVL4","quote":"quote-module--quote--3RKdC"};